import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import SalesPediaPage from '../modules/salesPediaMain/SalesPediaPage'
import SalesPediaFilePage from '../modules/salesPediaMain/SalesPediaFilePage'
import SalesPediaPageFish from '../modules/salesPediaMain/SalesPediaPageFish'
import SalesPediaPageKebab from '../modules/salesPediaMain/SalesPediaPageKebab'
import SalesPediaPageVegan from '../modules/salesPediaMain/SalesPediaPageVegan'
import { SubHierarchyWrapper } from '../pages/subHierarchyList/SubHierarchyWrapper'
import { ProductWrapper } from '../pages/product/ProductWrapper'
import { ProductTagWrapper } from '../pages/productTag/ProductTagWrapper'

export function PrivateRoutes() {


  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route exact path='/dashboard' component={DashboardWrapper} />

        <Route exact path='/subHierarchyList' component={SubHierarchyWrapper} />
        <Route exact path='/productDetail' component={ProductWrapper} />
        <Route exact path='/productTag' component={ProductTagWrapper} />




        <Route exact path='/salespediapage' component={SalesPediaPage} />
        <Route path='/salespediafilepage/:fileName' component={SalesPediaFilePage} />
        <Route exact path='/salespediapagefish' component={SalesPediaPageFish} />
        <Route exact path='/salespediapagekebap' component={SalesPediaPageKebab} />
        <Route exact path='/salespadiapagevegan' component={SalesPediaPageVegan} />
        <Route exact path='/menu-test' component={MenuTestPage} />
        <Redirect from='/auth' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
